import { commonImage } from 'constants/images';
import styled from 'styled-components';

export const StyledGsChartDashboard = styled.div`
  display: flex;
  gap: 20px;
  /* max-width: 1920px; */
  /* width: 100%; */
  /* margin: 0 auto; */

  /* @media (max-width: 1919px) {
    .chart-wrapper {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 1023px) {
    .chart-wrapper {
      display: flex;
    }
  }

  @media (max-width: 1919px) {
    width: 100%;

    .today-lists {
      .total {
        width: 30%;
      }
    }
  }

  @media (max-width: 1023px) {
    height: auto;
  } */
`;

export const StyledChartMapWrapper = styled.div`
  /* width: 1200px; */
  /* width: 950px; */
  flex: 2;
  padding: 16px;
  border-radius: 8px;
  position: relative;
  z-index: 2;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    /* width: 100%; */
    width: 950px;
    height: 100%;
    border-radius: 8px;
    background: url(${commonImage.gsBorder}) center center / contain no-repeat;

    z-index: -1;
  }

  /* > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  } */
`;

export const StyledGsChartMap = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    padding: 1px;
    border-radius: 8px;
    background: linear-gradient(
      113.75deg,
      #37dcb0 -19.99%,
      rgba(55, 220, 176, 0) 69.72%,
      #37dcb0 122.72%
    );

    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
    z-index: 10;
  }

  .iot-wrapper {
    position: absolute;
    left: 28px;
    top: 28px;
    z-index: 2;
  }

  .alert-wrapper {
    position: absolute;
    top: 28px;
    right: 28px;
    z-index: 2;
  }
`;

export const StyledChartCardWrapper = styled.div`
  /* width: calc(100% - 950px); */
  /* display: flex;
  flex-wrap: wrap;
  gap: 20px; */

  width: 300px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    padding: 1px;
    border-radius: 8px;
    background: linear-gradient(
      115.38deg,
      #0dffae -15.48%,
      rgba(13, 255, 174, 0.34) 9.57%,
      rgba(13, 255, 174, 0) 58.82%,
      rgba(13, 255, 174, 0.49) 110.66%,
      #0dffae 146.08%
    );

    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
    z-index: 10;
  }

  .pjt-gs,
  .notice-gs {
    > div {
      > div {
        border-radius: 8px;
        z-index: 1;
        min-width: 434px;
        width: 300px;
        height: 164px;

        > h2 {
          color: var(--color-white) !important;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
        }

        .pjt-lists {
          .pjt-list {
            > h3 {
              color: var(--color-white) !important;
            }

            > p {
              color: var(--color-white) !important;
            }
          }
        }
      }
    }
  }
`;
